module.exports = new __parcel__URL__("the-piper-at-the-gates-of-dawn.40117553.jpg").toString();